import { render, staticRenderFns } from "./ProductivityBarChart.vue?vue&type=template&id=18e5c66c&"
import script from "./ProductivityBarChart.vue?vue&type=script&lang=js&"
export * from "./ProductivityBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports